export default __webpack_public_path__ + "static/media/392.fdc495d3.png";